// auth.js
export function getToken() {
    return localStorage.getItem('auth_token');
  }
  
  export function isLoggedIn() {
    return !!getToken();
  }
  
  export function logout() {
    localStorage.removeItem('auth_token');
  }